<template>
    <div
        class="relative flex items-center w-full px-4 py-6 mb-4 bg-white border border-gray-200 shadow-sm rounded-"
    >
        <div
            @click="show = !show"
            class="absolute top-0 right-0 flex items-center justify-center w-8 h-8 text-gray-500 border-b border-l border-gray-100 cursor-pointer hover:text-gray-900"
        >
            <svg
                v-show="show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                ></path>
            </svg>
            <svg
                v-show="!show"
                class="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 15l7-7 7 7"
                ></path>
            </svg>
        </div>
        <div class="w-full px-4 mx-auto sm:px-6 lg:px-8">
            <div class="max-w-4xl mx-auto">
                <div class="flex justify-between" v-show="show">
                    <h2
                        ref="scrollToMe"
                        @click="show = !show"
                        class="text-xl font-extrabold leading-9 text-left text-blue-600 cursor-pointer sm:text-xl sm:leading-10"
                    >
                        {{ caDetails.name }}
                    </h2>

                    <div @click="removeOffer">
                        <base-icon
                            width="60"
                            height="60"
                            class="h-8 cursor-pointer"
                            icon-name="trash"
                            viewBox="0 0 20 20 "
                            iconColor="#6C98C6"
                        >
                            <icon-trash />
                        </base-icon>
                    </div>
                </div>
                <div v-show="!show">
                    <div class="mt-4 ml-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Type de l’article :</label
                        >
                        <radio-box
                            label="Produit"
                            :name="`article ${caDetails.id}`"
                            :value="caDetails.options"
                            @change="payload => (caDetails.options = payload)"
                        />
                        <radio-box
                            class="ml-6"
                            :name="`article ${caDetails.id}`"
                            label="Service"
                            :value="caDetails.options"
                            @change="payload => (caDetails.options = payload)"
                        />
                    </div>
                    <base-input
                        placeholder="Désignation"
                        v-model="caDetails.name"
                        :hasError="$v.caDetails.name.$error"
                        :errorMessage="
                            errorMessage('Désignation', $v.caDetails.name)
                        "
                        @blur="$v.caDetails.name.$touch()"
                    />
                    <base-number-input
                        label="Prix unitaire de vente (HT)"
                        :isCurrency="true"
                        v-model="caDetails.price"
                        :hasError="$v.caDetails.price.$error"
                        :errorMessage="
                            errorMessage('Prix de vente', $v.caDetails.price)
                        "
                        @blur="$v.caDetails.price.$touch()"
                    />
                    <base-number-input
                        label="Quantité vendue"
                        v-model="caDetails.quantiteVente"
                        :hasError="$v.caDetails.quantiteVente.$error"
                        :errorMessage="
                            errorMessage(
                                'Quantité vendu',
                                $v.caDetails.quantiteVente
                            )
                        "
                        @blur="$v.caDetails.quantiteVente.$touch()"
                    />
                    <label
                        class="block font-normal leading-5 tracking-wide text-gray-600 ext-sm m sm:font-normal sm:text-base sm:leading-10"
                    >
                        <span class="ml-2.5">Unité</span>
                    </label>
                    <SelectMenu
                        label="Unité"
                        :option="units"
                        v-model="caDetails.units"
                    />
                    <div class="mt-3 text-left">
                        <label
                            class="block my-2 mb-2 text-sm font-normal leading-5 tracking-wide text-gray-600 sm:font-normal sm:text-base sm:leading-10"
                            >Fréquence :</label
                        >
                        <div class="flex w-4/5">
                            <base-tag title="Mois" v-model="caDetails.date" />
                            <base-tag title="Année" v-model="caDetails.date" />
                        </div>
                    </div>
                    <div
                        v-if="!isSimplifiedVersion"
                        class="flex items-center mt-8"
                    >
                        <h5 class="mr-4">Export</h5>
                        <toggle
                            class="mr-6"
                            v-on:toggleTriggered="
                                e => (caDetails.isExported = e)
                            "
                            :triggered="caDetails.isExported"
                        />
                    </div>
                    <base-number-input
                        :max="100"
                        v-if="caDetails.isExported"
                        label="Pourcentage du CA de la part exportée (%)"
                        v-model="caDetails.pourcentagePartExportee"
                        :hasError="$v.caDetails.pourcentagePartExportee.$error"
                        :errorMessage="
                            errorMessage(
                                'Pourcentage du CA de la part exportée (%)',
                                $v.caDetails.pourcentagePartExportee
                            )
                        "
                        @blur="$v.caDetails.pourcentagePartExportee.$touch()"
                    />

                    <div class="flex justify-end mt-4 mr-6">
                        <base-secondary-button
                            color="red"
                            title="Supprimer"
                            @click="removeOffer"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconTrash from "@/components/icons/trash";
import SelectMenu from "@/components/forms/select/selectMenu";
import Toggle from "@/components/forms/Toggles/simpleToggle";
import RadioBox from "@/components/forms/Toggles/radioBox";
import {
    required,
    integer,
    decimal,
    minValue,
    maxValue,
    minLength,
    maxLength
} from "vuelidate/lib/validators";

import { mapState, mapGetters } from "vuex";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToRef } from "@/mixins/scrollToMixin.js";

export default {
    components: { IconTrash, SelectMenu, Toggle, RadioBox },
    props: {
        title: {
            type: String
        },
        object: {
            type: Object,
            required: true
        }
    },

    mixins: [errorMessage, scrollToRef],

    validations: {
        caDetails: {
            price: { required, decimal, minValue: minValue(0) },
            name: { minLength: minLength(3), maxLength: maxLength(75) },
            quantiteVente: { integer, minValue: minValue(0) },
            pourcentagePartExportee: {
                minValue: minValue(0),
                maxValue: maxValue(100)
            }
        }
    },
    data() {
        return {
            caDetails: this.object,
            show: false,
            isExported: false
        };
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapState("forms", {
            options: state => state.CADetails.options,
            units: state => state.units
        })
    },
    methods: {
        addCaDetails() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$store.dispatch(
                    "EtudeFinanciere/addCaDetails",
                    this.caDetails
                );
                this.show = true;
                return true;
            } else {
                this.show = false;
                return false;
            }
        },
        removeOffer() {
            this.$emit("remove", this.caDetails.id);
        }
    }
};
</script>

<style></style>
